/**
 * @author E45597 Aryamitra Chaudhuri
 * @description Firebase analytics event names.
 */

export default {
  CMEDComponentNames: {
    CMED_MARKET_DATA: "CMED_MARKET_DATA",
    CMED_ORDER_BOOK: "CMED_ORDER_BOOK",
    CMED_RFQ_FEED: "CMED_RFQ_FEED",
    CMED_BLOCK_FEED: "CMED_BLOCK_FEED",
    CMED_OPTIONS_GRID: "CMED_OPTIONS_GRID",
    CMED_QUIKSTRIKE: "CMED_QUIKSTRIKE",
    CMED_POSITIONS: "CMED_POSITIONS",
    CMED_BEACON: "CMED_BEACON",
  },
  eventNames: {
    CMED_ORDER_BOOK: {
      CMED_ORDER_BOOK_HOLD_ORDER: "CMED_ORDER_BOOK_HOLD_ORDER",
      CMED_ORDER_BOOK_KILL_ORDER: "CMED_ORDER_BOOK_KILL_ORDER",
      CMED_ORDER_BOOK_MODIFY_BID_ORDER: "CMED_ORDER_BOOK_MODIFY_BID_ORDER",
      CMED_ORDER_BOOK_MODIFY_OFFER_ORDER: "CMED_ORDER_BOOK_MODIFY_OFFER_ORDER",
      CMED_ORDER_BOOK_ACTIVE_ORDER: "CMED_ORDER_BOOK_ACTIVE_ORDER",
      CMED_ORDER_BOOK_VIEW_ORDER: "CMED_ORDER_BOOK_VIEW_ORDER",
      CMED_ORDER_BOOK_HOLD_ALL_ORDERS: "CMED_ORDER_BOOK_HOLD_ALL_ORDERS",
      CMED_ORDER_BOOK_KILL_ALL_ORDERS: "CMED_ORDER_BOOK_KILL_ALL_ORDERS",
      CMED_ORDER_BOOK_SEARCH_ORDER: "CMED_ORDER_BOOK_SEARCH_ORDER",
      CMED_ORDER_BOOK_APPLY_FILTER: "CMED_ORDER_BOOK_APPLY_FILTER",
      CMED_ORDER_BOOK_VIEW_WINDOW: "CMED_ORDER_BOOK_VIEW_WINDOW",
    },
    CMED_MARKET_DATA: {
      CMED_MARKET_DATA_ADD_NEW_CONTRACT: "CMED_MARKET_DATA_ADD_NEW_CONTRACT",
      CMED_MARKET_DATA_REMOVE_CONTRACT: "CMED_MARKET_DATA_REMOVE_CONTRACT",
      CMED_MARKET_DATA_NEW_BID: "CMED_MARKET_DATA_NEW_BID",
      CMED_MARKET_DATA_NEW_OFFER: "CMED_MARKET_DATA_NEW_OFFER",
      CMED_MARKET_DATA_SWITCH_TO_BID: "CMED_MARKET_DATA_SWITCH_TO_BID",
      CMED_MARKET_DATA_SWITCH_TO_OFFER: "CMED_MARKET_DATA_SWITCH_TO_OFFER",
      CMED_MARKET_DATA_VIEW_CONTRACT: "CMED_MARKET_DATA_VIEW_CONTRACT",
      CMED_MARKET_DATA_SWITCH_TO_CHART: "CMED_MARKET_DATA_SWITCH_TO_CHART",
      CMED_MARKET_DATA_EDIT_GRIDS: "CMED_MARKET_DATA_EDIT_GRIDS",
      CMED_MARKET_DATA_LIVE_VIEW: "CMED_MARKET_DATA_LIVE_VIEW",
    },
    CMED_OPTIONS_GRID: {
      CMED_OPTIONS_GRID_INSTRUMENT_SEARCH:
        "CMED_OPTIONS_GRID_INSTRUMENT_SEARCH",
      CMED_OPTIONS_GRID_NEW_BID: "CMED_OPTIONS_GRID_NEW_BID",
      CMED_OPTIONS_GRID_NEW_OFFER: "CMED_OPTIONS_GRID_NEW_OFFER",
      CMED_OPTIONS_GRID_ORDER_AGGRESSION_BID:
        "CMED_OPTIONS_GRID_ORDER_AGGRESSION_BID",
      CMED_OPTIONS_GRID_ORDER_AGGRESSION_OFFER:
        "CMED_OPTIONS_GRID_ORDER_AGGRESSION_OFFER",
      CMED_OPTIONS_GRID_SWITCH_TO_BID: "CMED_OPTIONS_GRID_SWITCH_TO_BID",
      CMED_OPTIONS_GRID_SWITCH_TO_OFFER: "CMED_OPTIONS_GRID_SWITCH_TO_OFFER",
      CMED_OPTIONS_GRID_GO_TO_STRIKE: "CMED_OPTIONS_GRID_GO_TO_STRIKE",
      CMED_OPTIONS_GRID_GO_TO_ATM: "CMED_OPTIONS_GRID_GO_TO_ATM",
      CMED_OPTIONS_GRID_ADD_NEW_INSTRUMENT:
        "CMED_OPTIONS_GRID_ADD_NEW_INSTRUMENT",
      CMED_OPTIONS_GRID_VIEW_WINDOW: "CMED_OPTIONS_GRID_VIEW_WINDOW",
    },
    CMED_BLOCK_FEED: {
      CMED_BLOCK_FEED_VIEW_WINDOW: "CMED_BLOCK_FEED_VIEW_WINDOW",
      CMED_BLOCK_FEED_SAVE_FILTER: "CMED_BLOCK_FEED_SAVE_FILTER",
    },
    CMED_POSITIONS: {
      CMED_POSITIONS_VIEW_WINDOW: "CMED_POSITIONS_VIEW_WINDOW",
      CMED_POSITIONS_AGGREGATED_VIEW: "CMED_POSITIONS_AGGREGATED_VIEW",
    },
    CMED_QUIKSTRIKE: {
      CMED_QUIKSTRIKE_VIEW_WINDOW: "CMED_QUIKSTRIKE_VIEW_WINDOW",
    },
    CMED_BEACON: {
      CMED_BEACON_CREATE_ALERT: "CMED_BEACON_CREATE_ALERT",
      CMED_BEACON_VIEW_MANAGE_ALERTS_WINDOW:
        "CMED_BEACON_VIEW_MANAGE_ALERTS_WINDOW",
    },
  },
};
